import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import {
  IntranetChannelList,
  type IntranetChannelListProps,
} from '@/products/intranet/components/intranet-channels';

type IntranetChannelSheetProps = IntranetChannelListProps & {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export function IntranetChannelSheet({
  open,
  onOpenChange,
  categories,
  activeSlug,
  saved,
  savedCount,
}: IntranetChannelSheetProps) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="left" className="overflow-y-auto">
        <SheetHeader>
          <SheetTitle>Meine Channels</SheetTitle>
        </SheetHeader>
        <IntranetChannelList
          categories={categories}
          activeSlug={activeSlug}
          saved={saved}
          savedCount={savedCount}
          onPick={() => onOpenChange(false)}
        />
      </SheetContent>
    </Sheet>
  );
}
